import React, { Component } from "react";
import {
  View,
  StyleSheet,
  I18nManager,
} from "react-native";
import Text from "../components_v2/TextFont";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import DeviceToggle from "./DeviceToggle";
import Slider from "@react-native-community/slider";


export default class DeviceDimmer extends Component {
  constructor(props) {
    super(props);
  }

  changeValueTo(val) {
    this.handleOnValueChange(val);
  }

  handleOnToggle = () => {
    if (this.props.onToggle) {
      this.props.onToggle();
    }
  };
  handleOnValueChange = (v) => {
    if (this.props.onValueChange) {
      this.props.onValueChange(v);
    }
  };

  render() {
    let defaultColor = "#FFE000";
    return (
      <View style={this.props.style}>
        <Text style={style.txtCurrentValue}>
          {this.props.currentValue || 0}%
        </Text>
        <View style={style.wrapper}>
          <FontAwesomeIcon
            icon={this.props.startIcon}
            size={30}
            color={this.props.startColor || "#ccc"}
            onPress={() => this.changeValueTo(0)}
          />
          <View style={{ flex: 3 }}>
            <Slider
              style={style.slider}
              value={this.props.currentValue}
              step={1}
              minimumValue={0}
              maximumValue={100}
              minimumTrackTintColor={this.props.startColor || defaultColor}
              thumbTintColor={this.props.startColor || defaultColor}
              onSlidingComplete={(v) => this.changeValueTo(v)}
              inverted={I18nManager.isRTL}
            />
          </View>
          <FontAwesomeIcon
            icon={this.props.endIcon || this.props.startIcon}
            size={42}
            color={this.props.endColor || defaultColor}
            onPress={() => this.changeValueTo(100)}
          />
          {this.props.hasToggle && (
            <DeviceToggle
              value={this.props.isTurnedOn}
              onToggle={() => this.handleOnToggle()}
              style={{ flex: 1, marginLeft: 10 }}
            />
          )}
        </View>
      </View>
    );
  }
}

const style = StyleSheet.create({
  txtCurrentValue: { textAlign: "center", color: "#ccc", fontSize: 42 },
  wrapper: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
  slider: { marginHorizontal: 5 },
});
